/**
 * API Configuration for UW-ERP Frontend
 * 
 * These values are loaded from environment variables at build time.
 * To change these values:
 *   1. Update your .env file (copy from .env.example)
 *   2. Rebuild the application (npm run build)
 * 
 * Environment variables are baked into the build and cannot be changed at runtime.
 */

// Load environment variables with fallbacks for development
const getEnvVar = (key: string, fallback: string): string => {
  const value = import.meta.env[key];
  
  if (!value) {
    console.warn(
      `Environment variable ${key} is not set. Using fallback: ${fallback}`
    );
    return fallback;
  }
  
  return value;
};

// API endpoint for REST calls
export const API_BASE_URL = getEnvVar(
  'VITE_API_BASE_URL',
  'https://localhost:7017/api/v1'
);

// Base URL for images and static assets
export const API_BASE_IMAGE_URL = getEnvVar(
  'VITE_API_BASE_IMAGE_URL',
  'https://localhost:7017'
);

// WebSocket/SignalR connection URL (for real-time features)
export const API_BASE_WEB_SOCKET = getEnvVar(
  'VITE_API_BASE_WEB_SOCKET',
  'https://localhost:7017'
);

// SignalR hub path (optional security token)
export const SIGNALR_HUB_PATH = import.meta.env.VITE_SIGNALR_HUB_PATH || '';

// Google Maps API Key
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

// Log configuration in development
if (import.meta.env.DEV) {
  console.log('🔧 API Configuration:', {
    API_BASE_URL,
    API_BASE_IMAGE_URL,
    API_BASE_WEB_SOCKET,
    SIGNALR_HUB_PATH: SIGNALR_HUB_PATH ? '***configured***' : 'not configured',
    GOOGLE_MAPS_API_KEY: GOOGLE_MAPS_API_KEY ? '***configured***' : 'not configured',
  });
}